module.exports = __webpack_public_path__ + "assets/img/6c25e2557b2c6a3c7f0a520710d3d60e.webp";